import { render, staticRenderFns } from "./TournamentStandingsBody.vue?vue&type=template&id=072b212c&"
import script from "./TournamentStandingsBody.vue?vue&type=script&lang=js&"
export * from "./TournamentStandingsBody.vue?vue&type=script&lang=js&"
import style0 from "./TournamentStandingsBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('072b212c')) {
      api.createRecord('072b212c', component.options)
    } else {
      api.reload('072b212c', component.options)
    }
    module.hot.accept("./TournamentStandingsBody.vue?vue&type=template&id=072b212c&", function () {
      api.rerender('072b212c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tournament/TournamentStandingsBody.vue"
export default component.exports